(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-wager/assets/javascripts/generate-boards.js') >= 0) return;  svs.modules.push('/components/numbergames/game-wager/assets/javascripts/generate-boards.js');

'use strict';

const _excluded = ["boards", "count"],
  _excluded2 = ["count"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const _svs$numbergames = svs.numbergames,
  gameWager = _svs$numbergames.gameWager,
  productMapping = _svs$numbergames.productMapping,
  _svs$numbergames$rule = _svs$numbergames.rules,
  getRules = _svs$numbergames$rule.getRules,
  systemRules = _svs$numbergames$rule.system;
function isInRange(value, range) {
  const _ref = range !== null && range !== void 0 ? range : {},
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 0 : _ref$max;
  return Number.isInteger(value) && value >= min && value <= max;
}
function verifyNumberArray(numbers, maxLength, maxValue) {
  if (!Array.isArray(numbers)) return [];
  const verifiedNumbers = [];
  const numbersSet = new Set();
  numbers.forEach(n => {
    const number = Number(n.number || n);
    const manual = Boolean(n.manual);
    if (isInRange(number, {
      min: 1,
      max: maxValue
    }) && !numbersSet.has(number)) {
      numbersSet.add(number);
      verifiedNumbers.push({
        number,
        manual
      });
    }
  });
  if (verifiedNumbers.length > maxLength) return [];
  return verifiedNumbers;
}

function getBoardOptionsHandler(rules) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const getIsSystemBoard = () => Boolean(options === null || options === void 0 ? void 0 : options.isSystemBoard);
  const getLevel = () => {
    var _rules$SYSTEM;
    const levels = getIsSystemBoard() ? (_rules$SYSTEM = rules.SYSTEM) === null || _rules$SYSTEM === void 0 ? void 0 : _rules$SYSTEM.levels : rules.levels;
    return isInRange(options.level, levels) ? options.level : levels === null || levels === void 0 ? void 0 : levels.preset;
  };
  const getHasKungKeno = () => {
    var _options$hasKungKeno;
    return rules.kungKeno && ((_options$hasKungKeno = options.hasKungKeno) !== null && _options$hasKungKeno !== void 0 ? _options$hasKungKeno : rules.kungKeno);
  };
  const getRowPrice = () => rules.rowPrice;
  const getRowPriceMulti = () => {
    var _rules$rowPriceMultip, _rules$rowPriceMultip2;
    return rules !== null && rules !== void 0 && (_rules$rowPriceMultip = rules.rowPriceMultipliers) !== null && _rules$rowPriceMultip !== void 0 && (_rules$rowPriceMultip2 = _rules$rowPriceMultip.includes) !== null && _rules$rowPriceMultip2 !== void 0 && _rules$rowPriceMultip2.call(_rules$rowPriceMultip, options.rowPriceMulti) ? options.rowPriceMulti : 1;
  };
  const getSystemSize = () => {
    var _options$systemSize;
    if (!getIsSystemBoard()) return;
    const _ref2 = (_options$systemSize = options.systemSize) !== null && _options$systemSize !== void 0 ? _options$systemSize : {},
      _ref2$numbersSize = _ref2.numbersSize,
      numbersSize = _ref2$numbersSize === void 0 ? 0 : _ref2$numbersSize,
      _ref2$extraNumbersSiz = _ref2.extraNumbersSize,
      extraNumbersSize = _ref2$extraNumbersSiz === void 0 ? 0 : _ref2$extraNumbersSiz;
    const _systemRules$systemLi = systemRules.systemLimits({
        rules,
        numberSize: numbersSize,
        numberExtraSize: extraNumbersSize,
        level: getLevel()
      }),
      numbersLimits = _systemRules$systemLi.numbersLimits,
      numbersExtraLimits = _systemRules$systemLi.numbersExtraLimits;
    const isValidSystemSize = isInRange(numbersSize, numbersLimits) && isInRange(extraNumbersSize, numbersExtraLimits);
    return {
      numbersSize: isValidSystemSize ? numbersSize : 0,
      extraNumbersSize: isValidSystemSize ? extraNumbersSize : 0
    };
  };
  const getRow = () => {
    var _ref3, _systemSize$numbersSi, _systemSize$extraNumb;
    const systemSize = getSystemSize();
    const numbersLength = (_ref3 = (_systemSize$numbersSi = systemSize === null || systemSize === void 0 ? void 0 : systemSize.numbersSize) !== null && _systemSize$numbersSi !== void 0 ? _systemSize$numbersSi : getLevel()) !== null && _ref3 !== void 0 ? _ref3 : rules.numbersMaxLength;
    const extraNumbersLength = (_systemSize$extraNumb = systemSize === null || systemSize === void 0 ? void 0 : systemSize.extraNumbersSize) !== null && _systemSize$extraNumb !== void 0 ? _systemSize$extraNumb : rules.numbersExtraMaxLength;
    return {
      numbers: verifyNumberArray(options.numbers, numbersLength, rules.numbersMaxValue),
      extraNumbers: verifyNumberArray(options.extraNumbers, extraNumbersLength, rules.numbersExtraMaxValue)
    };
  };
  return {
    getLevel,
    getHasKungKeno,
    getRowPrice,
    getRowPriceMulti,
    getIsSystemBoard,
    getSystemSize,
    getRow
  };
}

function generateBoard(product) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const rules = getRules(product, options.ruleOptions);
  if (!rules) {
    gameWager.logger.warn("Can not generate board. Could not find rules for ".concat(product));
    return;
  }
  const boardOptionsHandler = gameWager.getBoardOptionsHandler(rules, options);
  const _boardOptionsHandler$ = boardOptionsHandler.getRow(),
    numbers = _boardOptionsHandler$.numbers,
    extraNumbers = _boardOptionsHandler$.extraNumbers;
  const board = {
    productId: productMapping.getProductId(product),
    numbers,
    extraNumbers,
    level: boardOptionsHandler.getLevel(),
    hasKungKeno: boardOptionsHandler.getHasKungKeno(),
    rowPrice: boardOptionsHandler.getRowPrice(),
    rowPriceMulti: boardOptionsHandler.getRowPriceMulti(),
    isSystemBoard: boardOptionsHandler.getIsSystemBoard(),
    systemSize: boardOptionsHandler.getSystemSize()
  };
  if (options !== null && options !== void 0 && options.randomize) {
    var _gameWager$randomizeR = gameWager.randomizeRow(board);
    board.numbers = _gameWager$randomizeR.numbers;
    board.extraNumbers = _gameWager$randomizeR.extraNumbers;
  }
  return board;
}

function generateBoards(product, options) {
  const verifyCount = count => Number.isInteger(count) && count > 0 ? count : null;
  const _ref4 = options !== null && options !== void 0 ? options : {},
    _ref4$boards = _ref4.boards,
    boards = _ref4$boards === void 0 ? [{}] : _ref4$boards,
    count = _ref4.count,
    opts = _objectWithoutProperties(_ref4, _excluded);
  return boards.reduce((arr, board) => {
    const boardCount = board.count,
      boardOpts = _objectWithoutProperties(board, _excluded2);
    let numberOfBoards = verifyCount(boardCount) || verifyCount(count) || 1;
    while (numberOfBoards--) {
      arr.push(gameWager.generateBoard(product, _objectSpread(_objectSpread({}, opts), boardOpts)));
    }
    return arr;
  }, []).filter(Boolean);
}
Object.assign(svs.numbergames.gameWager, {
  getBoardOptionsHandler,
  generateBoard,
  generateBoards
});

 })(window);